import { atom } from 'jotai';

export const EVENT_ID = atom(0);
